import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/openlobby/$lobbyId")({
  component: () => <Outlet />,
});
